import { render, staticRenderFns } from "./RegistrationPage.vue?vue&type=template&id=ba5549de&"
import script from "./RegistrationPage.vue?vue&type=script&lang=js&"
export * from "./RegistrationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports